import React from 'react';
import { Helmet } from "react-helmet";
import { PROJECTNAME } from '../constants/custom_config';

import Headermain from './Headermain';
import Slidemenu from './Slidemenu';
import Nothing_here from './Nothing_here';


class No_booking_history extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - Booking History</title>
                </Helmet>
                <Headermain prop={this.props} />
                <div className="content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <Slidemenu  prop={this.props} />
                                <div className="booking-history content">
                                    <h3>Booking History</h3>

                                    <Nothing_here wrapperClass="common-nothing-wrapper no-history-wrapper" descriptionClass="common-nothing-description" descriptionText="No Booking yet" btnClass="common-nothing-btn add-member-btn" btnText="Book now"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default No_booking_history;